import styles from './Percentage.module.css';

export const PercentageBar = ({ width, getParams }) => {
  const {
    variantBarBgColorStart,
    variantBarBgColorStop,
    variantBarColorDirection,
  } = getParams;
  return (
    <div
      className={styles['percentage-bar']}
      style={{
        maxWidth: `${width}%`,
        backgroundImage: `linear-gradient(${variantBarColorDirection}deg, ${variantBarBgColorStart}, ${variantBarBgColorStop})`,
      }}
    />
  );
};
